import Joi from "joi";

const BedCategorySchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "string.empty": "Category Name is required.",
  }),
  priority: Joi.number().min(0).required().messages({
    "number.base": "Priority must be a number.",
    "number.min": "Priority cannot be negative.",
  }),
}).unknown(true);

export default BedCategorySchema;
